/**
 * Lazy modal registration to avoid circular dependencies.
 *
 * PostTags.tsx needs the modal type constants but importing them from the
 * modal index files (PostTagsModal/index.ts, PostLocationModal/index.ts)
 * triggers registerModal() side-effects that pull in the modal components.
 * Those components import from "ui", which creates a circular dependency
 * that breaks Jest tests.
 *
 * This module provides lazy registration functions that dynamically import
 * the modal components only when needed.
 */
import { registerModal } from "libs/modals";
import { POST_TAGS_MODAL, POST_LOCATION_MODAL } from "./modal-types";

let tagsModalRegistration: Promise<void> | undefined;
export function ensurePostTagsModalRegistered(): Promise<void> {
  tagsModalRegistration ??= import("./PostTagsModal/PostTagsModal")
    .then(({ default: PostTagsModal }) => {
      registerModal(POST_TAGS_MODAL, PostTagsModal);
    })
    .catch((error) => {
      tagsModalRegistration = undefined;
      throw error;
    });
  return tagsModalRegistration;
}

let locationModalRegistration: Promise<void> | undefined;
export function ensurePostLocationModalRegistered(): Promise<void> {
  locationModalRegistration ??= import("./PostLocationModal/PostLocationModal")
    .then(({ default: PostLocationModal }) => {
      registerModal(POST_LOCATION_MODAL, PostLocationModal);
    })
    .catch((error) => {
      locationModalRegistration = undefined;
      throw error;
    });
  return locationModalRegistration;
}
